export default __webpack_public_path__ + "static/media/MVX.c13e89b7.svg";